import { type Translation } from "./en";

export const ru: Translation = {
  ai_cards_generate: "Сгенерировать карточки",
  settings_lang: "Язык",
  copy_code: "Скопировать код",
  copied: "Скопировано",
  html_column: "Столбец",
  html_row: "Строка",
  logout: "Выйти",
  error_contact_support:
    "Произошла ошибка. Пожалуйста свяжитесь с поддержкой, чтобы мы могли помочь вам.",
  ai_card_input_mode_supports: "Поддерживаются разные языки",
  browser_no_personal_decks_start: "У вас еще нет персональных колод. ",
  browser_no_personal_decks_end: ". Удачного изучения! 😊",
  browser_no_personal_decks_link: "Рекомендуем посмотреть ",
  upgrade_pro: "Получить Pro",

  ai_speech_preview_free_title: "Обычная речь",
  ai_speech_preview_free_desc: "Роботизированная речь",
  ai_speech_preview_pro_desc: "Качественная речь с естественной интонацией",
  ai_speech_preview_free_lbl: "Бесплатно",
  ai_speech_lang_support: "Поддержка 30+ языков",
  ai_speech_listen: "Прослушать",
  voice_type_none: "Нет",

  login_google: "Войти через Google",
  youtube_channel: "YouTube канал",
  card_input_mode_changed: "Режим ввода карточки изменен",
  card_input_mode_manual: "Ручной ввод",
  card_input_mode_get: "то получите карточку",
  card_input_mode_type: "Если вы введете",
  card_input_mode_screen: "Режим ввода карточки",
  generate: "Сгенерировать",
  yes: "Да",
  ai_speech_title: "ИИ речь",
  ai_speech_empty: "Речь не создана. Выберите сторону карточки ниже.",
  ai_speech_generate: "Сгенерировать речь",
  ai_speech_type: "Или введите текст",
  ai_speech_validate: "Пожалуйста выберите сторону или введите текст",
  confirm_cancel: "Отмена",
  confirm_ok: "Подтвердить",
  payment_success:
    "Оплата прошла успешно. Наслаждайтесь дополнительными возможностями 😊",
  payment_failed:
    "Оплата не прошла. Мы знаем о проблеме и работаем над ней. Пожалуйста, свяжитесь с поддержкой через Настройки > Поддержка",
  error: "Ошибка",
  user_settings_updated: "Настройки обновлены",
  is_on: "Включено",
  is_off: "Выключено",
  folder_form_no_decks: "В папке нет колод",
  card_next: "Следующая",
  card_previous: "Предыдущая",
  folder_form_quit_card_confirm: "Выйти без сохранения папки?",
  read_more: "Читать далее",
  profile_section: "Профиль",
  review_again: "Снова",
  review_hard: "Сложно",
  review_good: "Хорошо",
  review_easy: "Легко",
  user_stats_empty_text: "Изучите больше карточек, чтобы увидеть данные",
  hide_card_forever_confirm_title:
    "Скрыть эту карточку навсегда? Вы больше не увидите её",
  hide_card_forever: "Скрыть навсегда",
  review_idk: "Не знаю",
  mute_cards: "Выключить звук",
  unmute_cards: "Включить звук",
  wysiwyg_text_color: "Цвет текста",
  wysiwyg_italic: "Курсив",
  next: "Далее",
  payment_pp: "Политикой конфиденциальности",
  privacy_policy: "Политика конфиденциальности",
  payment_and: " и ",
  payment_tos_and_pp_agree: "При покупке MemoCard вы соглашаетесь с ",
  payment_tos: "Условиями использования",
  payment_description: "Получите больше возможностей",
  payment_paid_until: "Оплачено до",
  payment_included: "Что включено",
  payment_choose_duration: "Длительность",
  payment_choose_subscription: "Подписка",
  payment_choose_method: "Способ оплаты",
  payment_method_stars: "Telegram Звёзды",
  payment_method_usd: "Банковская карта",
  ai_cards_left: "Осталось ИИ карточек на этот месяц",
  wysiwyg_clear_formatting: "Очистить форматирование",
  wysiwyg_bold: "Жирный",
  wysiwyg_big_header: "Большой заголовок",
  wysiwyg_undo: "Отменить",
  repeat_cards_anyway: `Всё равно повторить`,
  formatting: "Форматирование",
  validation_at_least_one_deck: "Пожалуйста выберите хотя бы 1 колоду",
  duplicate_folder_confirm: "Продублировать эту папку?",
  validation_answer_at_least_one_correct: "Выберите хотя бы 1 правильный ответ",
  add_answer: "Добавить ответ",
  answer_text: "Текст ответа",
  advanced: "Дополнительно",
  review_correct_label: "Правильно",
  review_wrong_label: "Неправильно",
  validation_at_least_one_answer_required: "Укажите хотя бы 1 ответ",
  card_preview: "Предпросмотр",
  deck: "Колода",
  add_deck_short: "Колода",
  deck_description: "Коллекция карточек",
  folder: "Папка",
  folder_description: "Коллекция колод",
  review_folder: "Пройти папку",
  add_deck_to_folder: "Добавить колоду в папку",
  decks_in_other_folders: "Колоды в других папках",
  add_folder: "Добавить папку",
  edit_folder: "Редактировать папку",
  no_decks_to_add: "Больше нет колод для добавления",
  decks: "Колоды",
  my_decks: "Мои колоды",
  show_all_decks: "Показать",
  hide_all_decks: "Скрыть",
  select_all: "Выбрать всё",
  deselect_all: "Снять выделение",
  select: "Выбрать",
  selected: "Выбрано",
  add_deck: "Добавить колоду",
  add: "Добавить",
  edit_deck: "Редактировать колоду",
  edit: "Изменить",
  view: "Просмотр",
  all_decks_reviewed: `Отличная работа! 🌟 Все колоды пройдены. Возвращайтесь позже за новыми.`,
  public_decks: "Публичные колоды",
  explore_public_decks: "Посмотреть еще",
  edit_card: "Редактировать карточку",
  news_and_updates: "Новости и обновления",
  telegram_channel: "Телеграм канал",
  settings: "Настройки",
  deck_has_been_added: "Колода уже в вашем списке",
  deck_catalog: "Каталог Колод",
  translated_to: "Переведено на",
  any_language: "Любой язык",
  category: "Категория",
  any_category: "Любая",
  deck_search_not_found: "Нет подходящих колод",
  card_search_not_found: "Карточки не найдены",
  deck_form_remove_card_confirm:
    "Удалить карточку? Все повторения этой карточки будут удалены",
  deck_form_remove_cards_confirm:
    "Вы уверены, что хотите удалить все выбранные карточки?",
  deck_search_not_found_description:
    "Попробуйте изменить фильтры чтобы увидеть больше",
  // TODO: move to database
  category_English: "Английский",
  category_Other: "Другое",
  category_Thai: "Тайский",
  category_Geography: "География",
  category_History: "История",
  category_Chemistry: "Химия",
  category_Spanish: "Испанский",
  save: "Сохранить",
  add_card: "Добавить карточку",
  card_front_title: "Лицевая сторона",
  card_back_title: "Обратная сторона",
  card_front_side_hint: "Вопрос или подсказка",
  card_back_side_hint: "Ответ",
  card_field_example_title: "Пример",
  card_field_example_hint: "Дополнительная информация (необязательно)",
  cards: "Карточки",
  search_card: "Поиск карточки",
  card_sort_by_date: "Дата",
  card_sort_by_front: "Вопрос",
  card_sort_by_back: "Ответ",
  sort_by: "Сортировка",
  title: "Название",
  description: "Описание",
  speaking_cards: "Озвучка карточек",
  voice_language: "Язык озвучки",
  card_speak_side: "Сторона карточки",
  front: "Лицевая",
  back: "Обратная",
  card_speak_description: "Позволяет услышать произношение",
  review_custom: "Выбрать что повторять",
  custom_due_cards: "Карточки к повторению",
  custom_new_cards: "Новые карточки",
  review_card_type: "Тип карточки",
  review_deck_finished: `Колода пройдена 🎉`,
  review_all_cards: `Вы повторили все карточки на сегодня 🎉`,
  review_finished_want_more: "Хотите ещё? У вас есть",
  review_finished_to_review: "для изучения",
  review_deck: "Пройти колоду",
  cards_to_repeat: "К повторению",
  cards_new: "Новые",
  cards_total: "Всего",
  duplicate: "Копировать",
  duplicate_deck_confirm: "Вы уверены, что хотите продублировать эту колоду?",
  delete_deck_confirm_shared: "Удалить колоду из вашей коллекции?",
  delete_folder_confirm_shared: "Удалить папку из вашей коллекции?",
  delete_folder_confirm_author:
    "Удалить папку из MemoCard? Это действие нельзя отменить",
  delete_deck_confirm_author:
    "Удалить колоду из MemoCard? Это действие нельзя отменить",
  delete: "Удалить",
  no_cards_to_review_in_deck: `Отличная работа! 🌟 Вы прошли все карточки в этой колоде. Возвращайтесь позже за новыми.`,
  no_cards_to_review_all: `Отличная работа! 🌟 Вы повторили все карточки на сегодня`,
  review_show_answer: "Показать ответ",
  share: "Поделиться",
  warning_telegram_outdated_title: "Ваш Телеграм устарел",
  warning_telegram_outdated_description:
    "Пожалуйста обновите Телеграм для стабильной работы приложения.",
  settings_review_notifications: "Напоминания о повторении",
  settings_time: "Время",
  settings_review_notifications_hint:
    "Ежедневные напоминания помогают не забывать повторять карточки",
  validation_deck_title: "Название колоды обязательно",
  deck_form_quit_card_confirm: "Выйти без сохранения карточки?",
  deck_form_quit_deck_confirm: "Выйти без сохранения колоды?",
  deck_category: "Категория колоды",
  add_card_short: "Карточка",
  validation_required: "Это поле обязательно",
  share_link_copied: "Ссылка скопирована",
  go_back: "Назад",
  settings_contact_support: "Связаться с поддержкой в Telegram",
  settings_support_hint: "Если у вас есть вопросы, проблемы или предложения",
  user_stats_btn: "Статистика",
  user_stats_page: "Моя статистика",
  user_stats_remembered: "Запомнено карточек",
  user_stats_remembered_hint: 'Нажато "Помню" 5 раз подряд',
  user_stats_learning: "В процессе изучения",
  user_stats_learning_hint: 'Нажато "Помню" менее 5 раз подряд',
  user_stats_total: "Всего карточек",
  user_stats_total_hint: "Карточки, открытые хотя бы один раз",
  user_stats_learning_time: "Распределение времени обучения",
  user_stats_learning_time_hint:
    "Как распределяется ваше время между изучением нового материала и повторением",
  user_stats_chart_min_expl: "Не помню карточку",
  user_stats_chart_max_expl: "Знаю карточку очень хорошо",
  card_answer_type: "Тип карточки",
  yes_no: "Помню",
  answer_type_choice: "Тест",
  answer_type_explanation_remember: `Карточка с кнопками "Помню" и "Не помню"`,
  answer_type_explanation_choice: `Карточка с вариантами ответов`,
  freeze_notified: "Вы получите уведомление",
  freeze_rule_1:
    "Все ваши карточки будут приостановлены, и вы не будете получать уведомлений.",
  freeze_for: "Заморозить на",
  how: "Как это работает",
  freeze_confirm_freeze:
    "Вы уверены, что хотите заморозить карточки? Это действие нельзя отменить.",
  freeze_title: "Заморозить карточки",
  freeze_for_or_manual: "или введите вручную",
  freeze_rule_2:
    "Количество карточек для повторения не увеличится во время заморозки; вы увидите тот же объем карточек что и сейчас, когда заморозка закончится.",
  freeze_rule_3: "Заморозка карточек необратима.",
  freeze_rule_4:
    "Если вы добавите карточку в период заморозки, она не будет затронута заморозкой.",
  validate_positive: "Пожалуйста, введите положительное число",
  validate_under_100: "Пожалуйста, введите число меньше 100",
  freeze_hint: "Отложите изучение карточек",
  ui_loading: "Загрузка...",
  error_solving: "Мы решаем проблему",
  ai_cards_added: "Карточки добавлены",
  quit_without_saving: "Выйти без сохранения?",
  ai_cards_prompt_back: "Обратная сторона карточки",
  ai_cards_no_previous_prompts: "Нет предыдущих запросов",
  ai_cards_prompt_front: "Лицевая сторона карточки",
  ai_cards_prompt: "Описание колоды",
  ai_cards_previous_prompts: "История запросов",
  ai_cards_use_template: "Использовать шаблон",
  ai_cards_by_ai: "Сгенерированные карточки",
  ai_cards_confirm_delete: "Удалить эту карточку?",
  ai_cards_title: "Генерация через ИИ",
  cards_add: "Добавить карточки",

  // Global Search
  global_search_placeholder: "Поиск колод, папок, карточек",
  global_search_no_results: "Ничего не найдено",
  global_search_cancel: "Отмена",
  global_search_start_typing:
    "Начните вводить текст для поиска колод, папок и карточек",
  global_search_tabs_cards: "Карточки",
  global_search_tabs_decks: "Колоды",
  global_search_tabs_folders: "Папки",
  global_search_context_folder: "Папка",
  global_search_context_deck: "Колода",

  // About page
  about_title: "О приложении",
  about_paragraph_1:
    "MemoCard создан из-за разочарования в существующих приложениях вроде Anki. Они мощные, но неудобные, требуют бесконечной настройки, не имеют умных уведомлений и выглядят устаревшими.",
  about_paragraph_2:
    "Во время конкурса мини-приложений Telegram я решил создать приложение для карточек, которое всегда хотел. Никакой настройки, умные напоминания и чистый интерфейс.",
  about_paragraph_3:
    "Приложение использует научно обоснованный алгоритм интервального повторения на основе кривой забывания Эббингауза. Это помогает эффективно запоминать языки, факты или любую информацию, показывая карточки именно тогда, когда их нужно повторить.",
  about_paragraph_4:
    "MemoCard получил приз в конкурсе. Сегодня тысячи людей используют его для лучшего обучения и запоминания.",
  about_visit_website: "Посетить сайт →",
  about_github_frontend: "GitHub репозиторий фронтенда →",

  // Card Input Mode Form
  card_input_mode_form_title: "Название",
  card_input_mode_form_ai_prompt: "AI запрос",
  card_input_mode_form_create_title: "Создать режим ввода",
  card_input_mode_form_edit_title: "Редактировать режим ввода",
  card_input_mode_form_delete_confirm: "Удалить этот режим ввода?",
  card_input_mode_add_button: "Добавить режим ввода",
  card_input_mode_form_title_placeholder: "напр. Английские определения",
  card_input_mode_form_prompt_placeholder:
    "напр. Сгенерируй карточку с определением для слова :template_word",
  card_input_mode_form_front_placeholder: "напр. Слово или термин",
  card_input_mode_form_back_placeholder: "напр. Простое определение",
  card_input_mode_form_example_placeholder:
    "напр. Пример использования или контекст",
  card_input_mode_form_save_success: "Режим ввода сохранен",
  card_input_mode_form_delete_success: "Режим ввода удален",
  quit_card: "Закрыть карточку",

  // Wysiwyg Help
  wysiwyg_help_title: "Как форматировать текст",
  wysiwyg_help_step1: "Выделите текст, который хотите изменить",
  wysiwyg_help_step2: "Нажмите любую кнопку на панели инструментов",
  wysiwyg_help_bold: "Жирный текст",
  wysiwyg_help_italic: "Курсивный текст",
  wysiwyg_help_color: "Изменить цвет текста",
  wysiwyg_help_heading: "Увеличить текст (заголовок)",
  wysiwyg_help_table: "Вставить таблицу",
  wysiwyg_help_clear: "Удалить все форматирование",
  wysiwyg_help_undo: "Отменить последнее действие",

  reverse_cards: "Обратные карточки",
  reverse_cards_title: "Обратные карточки",
  reverse_cards_helper: "Создай одну - получи две. Помогает лучше запоминать",
  two_cards_created: "Создано 2 карточки",
  card_created: "Карточка создана",

  // Move card to deck
  move_card_to_deck_title: "Переместить в колоду",
  move_card_without_folder: "Без папки",
  move_card_move: "Переместить",
  move_card_open_deck: "Открыть колоду",

  // Image related
  image: "Картинка",

  // Skip card
  skip_card_for_now: "Пропустить",
  skip_card_confirm: "Пропустить карточку? Она будет скрыта до следующего повторения",
  review_skipped: "Пропущено",
};
